<template>
    <v-card>
        <div class="LoaderWrapper"
             :class="{jsHidden:loaded}"
        >
            <v-progress-linear indeterminate color="primary"/>
        </div>
        <v-card-title class="CardTitle--big-center">
            Freedom Figure
            <HelpModal v-if="helpText"
                       :text="helpText"
                       :title="helpTitle"
            ></HelpModal>
        </v-card-title>
        <v-card-text>
            <v-data-table :headers="ffHeaders"
                          :items="ffItems"
                          disable-filtering
                          disable-sort
                          disable-pagination
                          hide-default-footer
                          class="FreedomFigureTable FreedomFigureTable--alt-shading"
            >
                <template v-slot:item.target_income="props">
                    <v-edit-dialog :return-value.sync="props.item.target_income"
                                   @save="save"
                                   @cancel="cancel"
                                   @open="open"
                                   @close="close"
                                   large
                    >
                        {{ formatDollar(props.item.target_income) }}
                        <template v-slot:input>
                            <v-text-field v-model="props.item.target_income"
                                          prefix="$"
                                          type="number"
                                          outlined
                                          label="Target Income"
                            >
                            </v-text-field>
                        </template>
                    </v-edit-dialog>
                </template>

                <template v-slot:item.package_price="props">
                    <v-edit-dialog :return-value.sync="props.item.package_price"
                                   @save="save"
                                   @cancel="cancel"
                                   @open="open"
                                   @close="close"
                                   large
                    >
                        {{ formatDollar(props.item.package_price) }}
                        <template v-slot:input>
                            <v-text-field v-model="props.item.package_price"
                                          type="number"
                                          outlined
                                          prefix="$"
                                          label="Package Price"
                            >
                            </v-text-field>
                        </template>
                    </v-edit-dialog>
                </template>

                <template v-slot:item.close_percentage="props">
                    <v-edit-dialog :return-value.sync="props.item.close_percentage"
                                   @save="save"
                                   @cancel="cancel"
                                   @open="open"
                                   @close="close"
                                   large
                    >
                        {{ formatNumber(props.item.close_percentage) }}%
                        <template v-slot:input>
                            <v-text-field v-model="props.item.close_percentage"
                                          type="number"
                                          outlined
                                          label="Close Percentage"
                            >
                            </v-text-field>
                        </template>
                    </v-edit-dialog>
                </template>

                <template v-slot:item.required_clients>
                    {{ formatNumber(requiredClients) }}
                </template>

                <template v-slot:item.monthly_calls>
                    {{ formatNumber(monthlyCalls) }}
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import axios from 'axios';
import HelpModal from '@/components/HelpModal';
import freedomFigureMixin from '@/views/Public/Card/freedomFigureMixin';

export default {
    mixins: [ freedomFigureMixin ],
    components: { HelpModal },

    props: [
        'name',
        'namespace'
    ],

    data() {
        return {
            loaded: true,
            id: null,
        };
    },

    mounted() {
        axios.get('/api/freedom-figure/user')
            .then(response => {
                this.freedomFigure = response.data.data.freedomFigure;
                this.ffItems.push(this.freedomFigure);
                this.id = this.freedomFigure.id;
                this.loaded = true;
            })
            .catch(error => {
                console.error(error);
                this.loaded = true;
            });
    },

    methods: {
        save() {
            if (this.freedomFigure.id) {
                axios.post('/api/freedom-figure/edit/' + this.freedomFigure.id, this.postData)
                    .then(response => {
                        console.log(response);
                    })
                    .catch(error => {
                        console.error(error);
                    });
            } else {
                axios.post('/api/freedom-figure/create', this.postData)
                    .then(response => {
                        console.log(response);
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        },
        cancel() {},
        open() {},
        close() {},
    }
};
</script>
<style lang="scss">
.FreedomFigureTable {
    margin-bottom: 18px !important;

    thead {
        th {
            border-color: rgba(#96ADC0, 0.3) !important;
        }
    }

    tbody {
        tr {
            td {
                border-color: rgba(#96ADC0, 0.3) !important;
                border-right: 1px solid;

                &:last-child {
                    border-right: 0 none;
                }
            }
        }

        tr:nth-child(even) {
            td {
                background-color: $neutral-100;
            }
        }

        tr:hover {
            td {
                background-color: #e6ebef !important;
            }
        }
    }
}

.FreedomFigureTable--alt-shading {
    tr:nth-child(even) {
        td {
            background-color: transparent;
        }
    }

    tr:nth-child(even):hover {
        td {
            background-color: #eeeeee;
        }
    }

    tr:nth-child(odd) {
        td {
            background-color: $neutral-100;
        }
    }

    tr:nth-child(odd):hover {
        td {
            background-color: #eeeeee;
        }
    }
}
</style>
